import { render, staticRenderFns } from "./modal-wrapper.component.vue?vue&type=template&id=0eeeff4f&"
import script from "./modal-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./modal-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports